import "@babel/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { registerDropdowns } from "../components/dropdown";
import { registerLogin } from "../components/login";
import ValentinesCards from "../components/r/valentines";
import { registerThemeHandler } from "../components/themes";
import { onReady } from "../utils/page-lifecycle";

onReady(() => {
  registerDropdowns();
  registerThemeHandler();
  registerLogin();
  registerDropdowns();

  let templates = document.getElementById("__valentines_templates__");
  if (templates) {
    templates = JSON.parse(templates.textContent);
  }

  ReactDOM.render(<ValentinesCards templates={templates} />, document.getElementById("valentines"));
});
